/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  defaultBlogs,
  mostLikedBlogs,
  newestBlogs
} from "../../features/blogs/blogsSlice";

function SortBlog() {
  const dispatch = useDispatch();
  const [sortTag, setSortTag] = useState("");

  const onChangeHandler = (e) => {
    if (e.target.value === "") dispatch(defaultBlogs());
    else if (e.target.value === "most_liked") dispatch(mostLikedBlogs());
    else if (e.target.value === "newest") dispatch(newestBlogs());
    setSortTag(e.target.value);
  };
  return (
    <select
      onChange={onChangeHandler}
      name="sort"
      id="lws-sort"
      className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
    >
      <option value="">Default</option>
      <option value="newest">Newest</option>
      <option value="most_liked">Most Liked</option>
    </select>
  );
}

export default SortBlog;
